module.exports = __webpack_public_path__ + "img/logo_with_wand.4e6785ea.png";